import React, { useEffect, useState } from 'react';
import TableHeader from '../../Shared/TableHeader';
import SelectDropdown from '../../Shared/SelectDropdown';
import CommonTable from '../../Shared/Tables';
import getColumnConfig from './UserOverAllReportGridColumnConfig';
import APIService from '../../../Services/APIService';
import { Row, Col } from 'react-bootstrap';
import { Box, Button, Typography, Grid, IconButton } from '@mui/material';

export default function UserAnalytics() {
  const [users, setUsers] = useState([]);
  const [filters, setFilters] = useState({ user: '', search: '' });
  const [campaignList, setCampaignList] = useState([]);

  const getUserList = async () => {
    let res = await APIService.get(`v0/user/?organisation_id=MAC1421`);
    if (res.status == 200) {
      let user = res?.data?.map((item) => ({ ...item, label: item?.username, value: item?.id }));
      setUsers(user);
    }
  };

  const handleChange = async (selectedOption) => {
    setFilters({ ...filters, user: selectedOption });
    let res = await APIService.get(`v0/ui/ops/user-analytics-today/?user_id=${selectedOption?.id}`);
    if (res.status == 200) setCampaignList(res?.data);
  };

  useEffect(() => {
    getUserList();
  }, []);
  return (
    <>
      <Row>
        <Col sm={12}>
          <Typography variant="h5" gutterBottom fontWeight="bold" textAlign="center">
            User Performance
          </Typography>
        </Col>
        <Col sm={{ span: 3, offset: 9 }}>
          <SelectDropdown
            optionsData={users}
            isClearable={false}
            selectedValue={filters.user}
            // selectedValue={filters?.user?.id}
            placeholder={'Select User'}
            label="Select User"
            id="SelectUser"
            handleSelect={handleChange}
          />
        </Col>
      </Row>

      {/* <div className="page-title-header">
        <div className="page-title-action-left"></div>
        <div className="page-title-center">
          <h4>User Performance</h4>
        </div>
        <div className="page-title-header-right">
          <SelectDropdown
            optionsData={users}
            selectedValue={filters?.user?.id}
            placeholder="Select User"
            label="Select User"
            id="SelectUser"
            
            handleSelect={handleChange}
          />{' '}
        </div>
      </div> */}
      <div>
        {campaignList.length > 0 ? (
          <CommonTable id={'campaign_id'} columnsData={getColumnConfig()} rowData={campaignList} />
        ) : (
          <div className="alert alert-info" role="alert" style={{ marginTop: '2em' }}>
            No supplier assigned to this user !
          </div>
        )}
      </div>
    </>
  );
}
